import { fetchWithToken } from '@/services'

const PLACE_ORDER = `
mutation placeOrderGuest(
  $inputSetBillingAddress: SetBillingAddressOnCartInput
  $inputSetPaymentMethod: SetPaymentMethodOnCartInput
  $inputPlaceOrder: PlaceOrderInput
) {
  setBillingAddressOnCart(input: $inputSetBillingAddress) {
    cart {
      ...CartFields
    }
  }

  setPaymentMethodOnCart(input: $inputSetPaymentMethod) {
    cart {
      selected_payment_method {
        code
        title
      }
      ...CartFields
      applied_coupons {
        code
      }
      total_quantity
      prices {
        grand_total {
          currency
          value
        }
      }
    }
  }
  placeOrder(input: $inputPlaceOrder) {
    order {
      order_number
    }
  }
}
fragment CartFields on Cart {
  id
  email
}`

const SHIPPING_METHOD_PAYMENT_METHOD_AND_PLACE_ORDER = `
mutation setPaymentMethodOnCartAndPlaceOrder(
    $setShippingMethodsOnCartInput: SetShippingMethodsOnCartInput
    $setPaymentMethodOnCartInput: SetPaymentMethodOnCartInput
    $placeOrderInput: PlaceOrderInput
) {
    setShippingMethodsOnCart(input: $setShippingMethodsOnCartInput) {
        cart {
            id
            email
            is_virtual
            shipping_addresses {
                selected_shipping_method {
                    amount {
                        currency
                        value
                    }
                    carrier_code
                    carrier_title
                    method_code
                    method_title
                }
            }
        }
    }
    setPaymentMethodOnCart(input: $setPaymentMethodOnCartInput) {
        cart {
            selected_payment_method {
                code
                purchase_order_number
                title
            }
        }
    }
    placeOrder(input: $placeOrderInput) {
        payment {
            account
            account_note
            account_number
            bank
            bank_id
            bank_logo
            qr_logo
        }
        orderV2 {
            entity_id
            order_number
            grand_total {
                currency
                value
            }
            protect_code
        }
    }
}
`

const SET_ADDRESS = `
  mutation setShippingAddress(
    $setShippingAddressesOnCartInput: SetShippingAddressesOnCartInput
    $setBillingAddressOnCartInput: SetBillingAddressOnCartInput
) {
    setShippingAddressesOnCart(input: $setShippingAddressesOnCartInput) {
        cart {
            ...CartFields
            shipping_addresses {
                available_shipping_methods {
                    amount {
                        currency
                        value
                    }
                    available
                    carrier_code
                    carrier_title
                    error_message
                    method_code
                    method_title
                }
                city
                district
                ward
                city_code
                district_code
                ward_code
                lastname
                firstname
                street
                selected_shipping_method {
                    amount {
                        currency
                        value
                    }
                    carrier_code
                    carrier_title
                    method_code
                    method_title
                }
                telephone
                postcode
            }
        }
    }
    setBillingAddressOnCart(input: $setBillingAddressOnCartInput) {
        cart {
            ...CartFields
        }
    }
}

fragment CartFields on Cart {
    is_virtual
    id
    email
}
`
const SET_GUEST_EMAIL = `
mutation setGuestEmailOnCart($input: SetGuestEmailOnCartInput) {
  setGuestEmailOnCart(input: $input) {
    cart {
      id
      email
      is_virtual
      total_quantity
    }
  }
}
`
export const setPaymentAndPlaceOrderActionV2 = async (data: IPaymentMethodAndPlaceOrderPayloadV2) => {
  try {
    return await fetchWithToken({ query: PLACE_ORDER, variables: data }).then((r) => {
      //   revalidateTag('/orders')
      return r as CommonResponse<IPlaceOrderResponseV2>
    })
  } catch (err) {
    console.log('error place order', err)
  }
}

export const setShippingMethodPaymentMethodAndPlaceOrder = async (
  data: IShippingMethodPaymentMethodAndPlaceOrderPayload
) => {
  try {
    return await fetchWithToken({
      query: SHIPPING_METHOD_PAYMENT_METHOD_AND_PLACE_ORDER,
      variables: data,
    }).then((r) => {
      //   revalidateTag('/orders')
      return r as CommonResponse<IPlaceOrderResponseV2>
    })
  } catch (err) {
    console.log('error place order', err)
  }
}
export const setGuestEmailAction = async (data: IGuestEmailPayload) => {
  try {
    return await fetchWithToken({ query: SET_GUEST_EMAIL, variables: data }).then((res) => {
      const errorMess = res?.payload?.errors?.[0]?.message
      if (!!errorMess) {
        throw new Error(errorMess)
      }
      return res
    })
  } catch (err) {
    console.log('error set guest email', err)
  }
}
export const setShippingAddressBillingAddress = async (data: IShippingAddressPayload) => {
  try {
    return await fetchWithToken({ query: SET_ADDRESS, variables: data }).then((res) => {
      const errorMess = res?.payload?.errors?.[0]?.message
      if (!!errorMess) {
        throw new Error(errorMess)
      }
      return res?.payload?.data
    })
  } catch (err) {
    console.log('error set shipping address', err)
  }
}
